/**
 * Created by Ivan on 19.01.2026
 */

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    LEVELMASTERY_EXTRABAR: {
        size: 35,
        color: cleverapps.styles.COLORS.WHITE
    }
});

const LevelMasteryExtraBarIcon = {
    customIcon: function () {
        return Prefab.instantiate(bundles.questsgroupicon.jsons.levelmastery_extrabar_icon_prefab_json);
    },
    extraBarWeight: 100003
};
